import {
  GET_VENDOR_DASHBOARD_MATRIX,
  GET_VENDOR_DASHBOARD_MATRIX_SUCCESS,
  GET_VENDOR_DASHBOARD_MATRIX_ERROR,
  GET_VENDOR_DASHBOARD_MATRIX_EMPTY,
} from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetVendorDashboardMatrix = (state = initialState, action) => {
  switch (action.type) {
    case GET_VENDOR_DASHBOARD_MATRIX:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_VENDOR_DASHBOARD_MATRIX_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_VENDOR_DASHBOARD_MATRIX_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_VENDOR_DASHBOARD_MATRIX_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetVendorDashboardMatrix;
